import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Transition as _Transition, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7296d722"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content rel" }
const _hoisted_2 = { class: "pop" }
const _hoisted_3 = { class: "icon" }
const _hoisted_4 = { class: "error-info" }

import { ref, watch } from 'vue'
import { t } from '@/plugins/i18n'
import { useRule } from '@/util/useRules'
import SvgIcon from '@/components/icons/SvgIcon.vue'

export default /*#__PURE__*/_defineComponent({
  props: ['product', 'adt', 'isBackSku'],
  emits: ['change', 'close'],
  setup(__props, { emit }) {

const props = __props



const newSize = ref(props.adt.additionExtraName)

watch(() => props.product, () => {
  if (props.isBackSku && props.adt.additionCode === 63) {
    console.log(props.product)
    newSize.value = (props.adt.additionExtraName || props.product?.thirdItemSku?.thirdItemAttribute || props.product?.thirdItemAttribute || '').slice(0, 10)
  }
  console.log('props.product', props.product)
}, {
  immediate: true,
  deep: true
})
const info = ref('')
const valid = () => {
  info.value = ''
  useRule('plain')[0].validator({}, newSize.value, (res:any) => {
    info.value = res
  })
  return info.value
}

const change = (v:boolean) => {
  if (v) {
    if (!newSize.value) {
      info.value = t('填写尺码 如：Ｆ，XS，S，M，2XL等')
      return
    }
    if (valid()) {
      return
    } else {
      props.adt.additionExtraName = newSize
    }
  }
  emit('change', v)
  setTimeout(() => {
    emit('close')
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createBlock(_Transition, {
    name: "el-zoom-in-top",
    duration: 500
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_tooltip, {
          effect: "dark",
          placement: "top-end",
          "hide-after": 50,
          "popper-class": "size-prop-tip"
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, _toDisplayString(((__props.product?.productPropertiesName || __props.product?.platformItemSku?.productPropertiesName || '').split(';') || []).map((e) =>
                  (e.replace(/[+-]?\d+\:[+-]?\d+\:/, '') || '').split(':')[1] ?? '').join(',') ||  _unref(t)('原商品尺码')), 1)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              readonly: "",
              "model-value": ((__props.product?.productPropertiesName || __props.product?.platformItemSku?.productPropertiesName || '').split(';') || []).map((e) =>
                  (e.replace(/[+-]?\d+\:[+-]?\d+\:/, '') || '').split(':')[1] ?? '').join(',') ||  _unref(t)('原商品尺码'),
              disabled: true
            }, null, 8, ["model-value"])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)("变更")), 1),
        _createVNode(_component_el_input, {
          modelValue: newSize.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newSize).value = $event)),
          maxlength: 10,
          onBlur: valid,
          placeholder: _unref(t)('填写尺码 如：Ｆ，XS，S，M，2XL等'),
          class: _normalizeClass({error:info.value})
        }, null, 8, ["modelValue", "placeholder", "class"]),
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createVNode(SvgIcon, { name: "提示" }, null, 512), [
            [_vShow, info.value]
          ]),
          _createTextVNode(" " + _toDisplayString(info.value), 1)
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (change(true)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("保存")), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_el_button, {
            type: "primary",
            plain: "",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (change(false)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("取消尺码变更")), 1)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }))
}
}

})